import type { JSX, ReactNode } from 'react';
import React from 'react';

import * as styles from './MascotAssistant.css';

import defaultMascotImage from '@feathr/extender/images/super_pixel_mascot.png';

interface IMascotAssistantProps {
  text: ReactNode;
  mascotImage?: string;
}

function MascotAssistant({
  text,
  mascotImage = defaultMascotImage,
}: Readonly<IMascotAssistantProps>): JSX.Element {
  return (
    <div className={styles.root}>
      <div className={styles.speechBubble}>{text}</div>
      <img alt={'Mascot'} className={styles.mascotImage} src={mascotImage} />
    </div>
  );
}

export default MascotAssistant;
